import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session3 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bienvenue dans une nouvelle session ! </h3>
            <p>
              Aujourd’hui, nous allons parler des tout-petits… et plus
              précisément des bébés. Maintenant que tu en sais un peu plus sur
              l’altruisme, à ton avis, est-ce que les bébés sont altruistes ?
            </p>
            <p>Allons voir !</p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1ECLruh4wWWg-W84DlQPmJSDB3dLlciW25SPs1hHzKAE"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
              Dans la vidéo, est-ce que les bébés aident les adultes à ramasser les pinces à linge ?
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="oui"
                  control={<Radio />}
                  label="Oui"
                />
                <FormControlLabel
                  value="non"
                  control={<Radio />}
                  label="Non"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}

        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Après cette découverte de l’altruisme chez les petits, nous allons
              changer de domaine.
            </p>
            <p>
              Nous les voyons souvent de loin, sur scène, mais connais-tu des
              artistes d’opéra ? C’est l’occasion d’aller à la rencontre de
              Niall Anderson.
            </p>
            <p>Clique sur le bouton continuer</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <iframe
              style={{display: 'block', margin: 'auto'}}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/VsqsQmoYZ5w"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <p>
              Quand tu as terminé de regarder la vidéo, clique sur le bouton
              ci-dessous.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. N’oublie pas de te
              reconnecter dans quelques jours pour notre prochaine séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Lors des dernières séances, tu as pu t’exprimer sur les mots de
                l’altruisme et ce qu’ils voulaient dire pour toi.
              </p>
              <p>
                Aujourd’hui, tu vas pouvoir en savoir un peu plus sur le thème
                que tu as sélectionné.
              </p>
              <p>
                On y va ? Clique sur le bouton « Continuer » quand tu es
                prêt(e).
              </p>
            </div>
          )}
        {group.toString() === 'test_a' && scr === 3 && (
          <div>
            <p>
              L’écologie englobe beaucoup de sujets : la nature, les animaux,
              mais aussi les humains. Le réchauffement climatique a beaucoup de
              conséquences. Un des effets est la montée des eaux dans les
              régions côtières ou dans les îles.
            </p>
            <p>
              Partons à la rencontre des habitants de la petite île de Tuvalu,
              pour qui la montée des eaux est un risque très important. Tu peux
              prendre des notes si tu en as envie.
            </p>
            <p>Clique sur la vidéo pour la regarder en entier. </p>
            <iframe
              title="testA_vid"
              frameborder="0"
              type="text/html"
              src="https://www.dailymotion.com/embed/video/xba1dz"
              width="100%"
              height="300"
              allowfullscreen
            ></iframe>
            <p>
              Quand tu as terminé de regarder la vidéo, clique sur le bouton
              ci-dessous.
            </p>
          </div>
        )}
        {group.toString() === 'test_b' && scr === 3 && (
          <div>
            <p>
              Passer du temps à l’hôpital n’est facile pour personne. Pour les
              enfants, être à l’hôpital bouscule la vie quotidienne.
            </p>
            <p>
              Partons à la rencontre d’un jeune garçon hospitalisé pour en
              savoir plus sur sa maladie et ses journées à l’hôpital. Tu peux
              prendre des notes si tu en as envie.
            </p>
            <p>Clique sur la vidéo pour la regarder en entier. </p>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/-wtRn2qW2rk"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <p>
              Quand tu as terminé de regarder la vidéo, clique sur le bouton
              ci-dessous.
            </p>
          </div>
        )}
        {group.toString() === 'test_c' && scr === 3 && (
          <div>
            <p>
              La pauvreté a de nombreuses facettes. Elle peut s’exprimer par des
              difficultés pour s’acheter à manger, de quoi s’habiller, se
              soigner… ou encore se loger.
            </p>
            <p>
              Partons à la rencontre de familles, et d’enfants, qui ont du mal à
              trouver un endroit où s’installer durablement. Tu peux prendre des
              notes si tu en as envie.
            </p>
            <p>Clique sur la vidéo pour la regarder en entier. </p>
            <iframe
              title="testC_vid"
              frameborder="0"
              type="text/html"
              src="https://www.dailymotion.com/embed/video/x5aasy3"
              width="100%"
              height="100%"
              allowfullscreen
            ></iframe>
            <p>
              Quand tu as terminé de regarder la vidéo, clique sur le bouton
              ci-dessous.
            </p>
          </div>
        )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Dans cette vidéo, tu as pu découvrir la vie de personnes
                affectées par le sujet que tu as choisi pour ton engagement.
              </p>
              <p>
                Pour la prochaine séance, prends le temps de réfléchir à quelles
                questions tu voudrais leur poser si tu le pouvais, ce dont tu
                voudrais discuter avec eux.
              </p>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                reconnecter dans quelques jours pour notre prochaine séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr===1){
             // save TEST DATA

             let now = new Date();
             firebase
               .databehav(firebase.userData.pseudo)
               .collection('session3')
               .add({
                 date: now,
                 response: response
               })
               .catch((error) => {
                 console.log(error);
               });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session3;
